import { AD_POSITION } from "@/constants/ads";
import { isSpiderClient } from "@/utils/isSpider";
import { memorizeFn } from "@/utils/memorizeFn";
import { isArray } from "lodash";
import { match } from "path-to-regexp";
import request, { env } from "../utils/request";
import { getGrocery } from "./global";

const ENV_MAP = {
  dev: "staging",
  fat: "staging",
  stage: "staging",
  prod: "production",
};

/**
 * 获取广告
 * https://yapi.gaoding.com/project/1536/interface/api/123990
 * @param {Object} params
 * @param {Array} params.positions 广告位
 * @param {Object=} params.variables 广告位变量
 * @param {Object=} params.headers
 *  */
export async function getAds({ positions, variables, headers, ...query }) {
  try {
    // 爬虫客户端渲染，不请求广告
    if (isSpiderClient(headers?.["user-agent"])) {
      return [];
    }

    const result = await request({
      method: "post",
      url: "/ads",
      ignoreMessage: true,
      ignoreError: true,
      timeout: 2000,
      data: {
        positions,
        variables: {
          env: [ENV_MAP[env]],
          ...variables,
        },
        ...query,
      },
      ...(headers
        ? {
            headers,
          }
        : null),
    });

    return isArray(result) ? result : [];
  } catch (e) {
    return [];
  }
}

/**
 * 获取顶部广告配置
 * @type {()=>Promise<{ads: {path: string, user_tag: string}[]}>}
 */
export const getAdsTopConfig = memorizeFn(() =>
  getGrocery("ads-top-page", {
    serverSide: typeof window !== "undefined",
    timeout: 2500,
  }).catch(() => ({}))
);

/**
 * 获取顶部广告
 * @param {{
 *  cookie?: string;
 *  userAgent?: string;
 *  url: string;
 *  adTopConfig: {ads: {path: string, user_tag: string}[]}
 * }} param
 */
export async function getTopAds({ cookie, userAgent, url, adTopConfig }) {
  const matchConfig = adTopConfig?.ads?.find((ad) => {
    try {
      return match(ad?.path)(url);
    } catch (error) {
      return false;
    }
  });

  const { TOP, NAV_TOP_RIGHT, TOP_PAGE } = AD_POSITION;

  return getAds({
    positions: matchConfig
      ? [TOP, NAV_TOP_RIGHT, TOP_PAGE]
      : [TOP, NAV_TOP_RIGHT],
    headers: {
      ...(cookie ? { cookie } : null),
      ...(userAgent ? { "user-agent": userAgent } : null),
    },
    variables: {
      user_tag: matchConfig ? [matchConfig.user_tag] : [],
    },
  });
}
